@if ((media$ | async); as media) {
  <img src="{{cmsURL}}{{media?.attributes?.url}}">
}
